import * as React from 'react';
import { useEffect, useState } from 'react';
import Section, { SubSection } from "../../Commons/Section";
import DataFrame from "../../Commons/Components/DataFrame";
import { Row as DataFrameRow } from "../../Commons/Components/DataFrame/types";
import { useContent } from "../../Content/cms";
import Apirest from "../../Content/Apirest";

interface DomainCompositeScoreItem {
    domain: string;
    score?: number;
    show?: boolean;
}

interface DomainCompositeResultsProps {
    protocolResId: string;
}

const DomainCompositeResults: React.FC<DomainCompositeResultsProps> = ({ protocolResId }) => {

    let getContent = useContent();
    let [rows, setRows] = useState<DataFrameRow[]>([]);

    useEffect(() => {
        if (!protocolResId) return;
        Apirest.get_protocol_res_domain_composite_scores(
            protocolResId,
            (response: DomainCompositeScoreItem[] | { results: DomainCompositeScoreItem[] }) => {
                const items: DomainCompositeScoreItem[] = Array.isArray(response)
                    ? response
                    : (response as any)?.results || [];

                // Respect backend `show` flag (default: visible)
                const visibleItems = items.filter(item => item.show !== false);

                const mapped: DataFrameRow[] = visibleItems
                    .filter((item) => {
                        return typeof item.score === 'number';
                    })
                    .map((item) => {
                        const domainKey = item.domain || '';
                        const nameKey = `protocol_result__composite__domains__${domainKey}__name`;
                        const explanationKey = `protocol_result__composite__domains__${domainKey}__explanation`;

                        const displayName = getContent(nameKey) || item.domain;

                        const rawScore = item.score;
                        const score = Math.round(rawScore as number);

                        const explanation = getContent(explanationKey) || '';

                        return [
                            <p className={'m-0 domain-name'}>{displayName}</p>,
                            <p className={'m-0 domain-score text-center'}>{score}</p>,
                            <p className={'m-0 domain-explanation'}>{explanation}</p>
                        ];
                    });

                setRows(mapped);
            }
        );
    }, [protocolResId]);

    if (rows.length === 0) return null;

    const header = [
        <p className={'m-0'}>{getContent('protocol_result__composite__header__domain')}</p>,
        <p className={'m-0 text-center'}>{getContent('protocol_result__composite__header__score')}</p>,
        <p className={'m-0'}>{getContent('protocol_result__composite__header__explanation')}</p>
    ];

    return (
        <Section
            title={getContent('protocol_result__composite__title')}
            className={'secondary-section protocol-composite-section'}
            headerClassName={'secondary-section-header'}
            bodyClassName={'secondary-section-body'}
        >
            <SubSection title={''} className={'secondary-subsection'}>
                <DataFrame
                    header={header}
                    dataframe={rows}
                    className={'header-bordered mt-3 w-100'}
                    columnClassName={'align-middle'}
                    pageSize={rows.length + 1}
                    columnWidths={[25, 10, 65]}
                    sortableColumns={[]}
                />
            </SubSection>
        </Section>
    );
};

export default DomainCompositeResults;

